/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkOrderSiteQueryReferenceDto } from './workOrderSiteQueryReferenceDto';

export interface CreateWorkOrderSiteQueryRequest {
  revision?: string;
  taskId?: string;
  title?: string;
  deliveryId?: string;
  site?: string;
  discipline?: string;
  reason?: CreateWorkOrderSiteQueryRequest.ReasonEnum;
  caseType?: CreateWorkOrderSiteQueryRequest.CaseTypeEnum;
  quantityChange?: boolean;
  scheduleImpact?: boolean;
  materialNeed?: boolean;
  description?: string;
  suggestedSolution?: string;
  references?: string;
  selectedReferences?: Array<WorkOrderSiteQueryReferenceDto>;
  initiatedBy?: string;
  company?: string;
  queryDate?: string;
  siteLeader?: string;
  integrationManager?: string;
}
export namespace CreateWorkOrderSiteQueryRequest {
  export const ReasonEnum = {
    Clarify: 'CLARIFY',
    Quantity: 'QUANTITY',
  } as const;
  export type ReasonEnum = (typeof ReasonEnum)[keyof typeof ReasonEnum];
  export const CaseTypeEnum = {
    ToleranceDeviation: 'TOLERANCE_DEVIATION',
    OffshoreChange: 'OFFSHORE_CHANGE',
    MaterialRepair: 'MATERIAL_REPAIR',
    OtherClarification: 'OTHER_CLARIFICATION',
  } as const;
  export type CaseTypeEnum = (typeof CaseTypeEnum)[keyof typeof CaseTypeEnum];
}
